import { Box, IconButton, Stack, styled, TableBody, TableCell, TableCellProps } from "@mui/material";
import { isNil } from "lodash";
import { styledOmitPropsOptions } from "../../theme/styled.helpers";
import { BodyTextM } from "../Typography";

export const BoldCell = styled(
    (props: TableCellProps & { $width?: string | number; $align?: AlignSetting }) => <TableCell {...props} />,
    styledOmitPropsOptions,
)(({ theme, $width, $align }) =>
    theme.unstable_sx({
        fontWeight: theme.typography.fontWeightBold,
        ...(!isNil($width) && { width: $width }),
        ...(!isNil($align) && { textAlign: $align }),
    }),
);

export const NoWrapCell = styled(
    TableCell,
    styledOmitPropsOptions,
)<{ $align?: AlignSetting }>(({ theme, $align }) =>
    theme.unstable_sx({
        whiteSpace: "nowrap",
        ...(!isNil($align) && { textAlign: $align }),
    }),
);

export const BoldCellNoWrap = styled(
    TableCell,
    styledOmitPropsOptions,
)<{ $width?: string | number; $align?: AlignSetting }>(({ theme, $align, $width }) =>
    theme.unstable_sx({
        fontWeight: theme.typography.fontWeightBold,
        whiteSpace: "nowrap",
        ...(!isNil($align) && { textAlign: $align }),
        ...(!isNil($width) && { width: $width }),
    }),
);

export const BoldBodyTextM = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        fontWeight: theme.typography.fontWeightBold,
    }),
);

export const InfoListItemButton = styled(
    IconButton,
    styledOmitPropsOptions,
)<{ $noRightPadding?: boolean }>(({ theme, $noRightPadding }) =>
    theme.unstable_sx({
        alignSelf: "flex-start",
        minWidth: "18px",
        height: "max-content",
        minHeight: "18px",
        ...($noRightPadding ? { pr: theme.spacing(0) } : {}),
    }),
);

export const InsuranceCoverageTableBody = styled(TableBody)(({ theme }) =>
    theme.unstable_sx({
        "& tr > td:first-of-type": { paddingLeft: theme.spacing(0) },
        "& tr > td:last-of-type": { paddingRight: theme.spacing(0) },
        "& tr:last-of-type > td": { borderBottom: "none" },
        "& tr:first-of-type > td": { borderBottom: "none" },
        "& td": { paddingX: theme.spacing(3) },
    }),
);

export const InsuranceCoverageMobileTableBody = styled(TableBody)(({ theme }) =>
    theme.unstable_sx({
        "& tr > td:first-of-type": { paddingLeft: theme.spacing(0) },
        "& tr > td:last-of-type": { paddingRight: theme.spacing(0) },
        "& tr:last-of-type > td": { borderBottom: "none" },
    }),
);

export const NarrowCell = styled(TableCell)(({ theme }) =>
    theme.unstable_sx({
        lineHeight: 1,
    }),
);

export const InsuranceCoverageWrapperBox = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        padding: theme.spacing(4),
    }),
);

export const ItemsBetweenStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
    }),
);

export const InsuranceCoverageBeneficiariesModalBodyStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        pb: theme.spacing(4),
    }),
);

export const InsuranceCoverageMobileLinkTitle = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        py: theme.spacing(3),
        px: theme.spacing(2),
        flexGrow: 1,
        textAlign: "left",
    }),
);

export const InsuranceCoverageMobileLinkWrapperStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        flexWrap: "nowrap",
    }),
);

export const InsuranceCoverageMobileBeneficiariesWrapperStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        px: theme.spacing(2),
        gap: theme.spacing(2),
        display: "flex",
        justifyContent: "start",
        flexDirection: "row",
        alignItems: "center",
    }),
);

export const InsuranceCoverageMobileOrangeBodyTextM = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        color: theme.palette.primary.main,
    }),
);
